import { render, staticRenderFns } from "./ReturnAssetIssuance.vue?vue&type=template&id=f281346e"
import script from "./ReturnAssetIssuance.vue?vue&type=script&lang=js"
export * from "./ReturnAssetIssuance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports